/**
 * Distribution System Configuration
 *
 * These values are hardcoded based on our current implementation.
 * They reference centralized financial constants where appropriate.
 */

import { OPTIMIZATION_CONSTANTS, PRINCIPAL_AMOUNTS } from '~/config/financial-constants';

/**
 * Distribution configuration constants
 */
export const DISTRIBUTION_CONFIG = {
  /**
   * Minimum distribution amount to avoid tiny allocations
   */
  MINIMUM_DISTRIBUTION_AMOUNT: PRINCIPAL_AMOUNTS.MINIMUM_PRINCIPAL,

  /**
   * Principal increment for rounding (matches prototype)
   */
  PRINCIPAL_INCREMENT: PRINCIPAL_AMOUNTS.PRINCIPAL_INCREMENT,

  /**
   * Iteration limits for constraint resolution
   */
  MAX_CONSTRAINT_ITERATIONS: 10,

  /**
   * Tolerance for convergence checks (dollars)
   */
  CONVERGENCE_TOLERANCE: OPTIMIZATION_CONSTANTS.CONVERGENCE_TOLERANCE,
} as const;

// Note: The following hardcoded values are used directly in the code:
// - TARGET_ROUNDING_UP: true (always round up for targeted bonds)
// - YEAR_PERCENTAGE_BASIS: "remaining" (use remaining years for calculations)
// - TARGET_PRIORITY_BUFFER: 0.05 (5% buffer for targeted allocations)
